import { UserID } from '@playq/octopus-common';
import { CommonSuccess, GenericFailure } from '@playq/services-shared';

import { services2 } from '/api/services2';
import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';

import { restoreUserMutationKey } from './constants';

export const useUserRestore = (options?: UseMutationOptionsExtended<CommonSuccess, GenericFailure | Error, UserID>) => {
  return useEitherMutation((id) => services2.adminUsersService.restore(id), {
    mutationKey: restoreUserMutationKey,
    ...options,
  });
};
